import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { EAnalyticsEvents } from '@/_analytic/_types';
import { TRecommendedLinkClickEventParams } from './types';

export const recommendedLinkClickEvent = (
  params: TRecommendedLinkClickEventParams,
) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.IN_ARTICLE_CLICK_RECOMMENDED_LINK,
    params,
  });
};
